import { apiUrl } from "../taskpane";

const parseResponse = async (response) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = data?.detail || "Request failed";
    const error = new Error(message);
    error.status = response.status;
    error.body = data;
    throw error;
  }
  return data;
};

export async function fetchProjects(token) {
  const res = await fetch(apiUrl("projects"), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return parseResponse(res);
}

export async function createProject(token, data) {
  const res = await fetch(apiUrl("create_project"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return parseResponse(res);
}

export async function updateProject(token, id, data) {
  console.log("Update data:", data);
  const jsonBody = JSON.stringify(data);
  console.log("JSON being sent:", jsonBody);
  const res = await fetch(apiUrl(`projects/${id}`), {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: jsonBody,
  });
  const response = await parseResponse(res);
  console.log("Response:", response);
  return response;
}

export async function duplicateProject(token, id, data = {}) {
  const res = await fetch(apiUrl(`projects/${id}/duplicate`), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
  return parseResponse(res);
}

export async function deleteProject(token, id) {
  const res = await fetch(apiUrl(`projects/${id}`), {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const error = new Error(data?.detail || "Unable to delete project");
    error.status = res.status;
    error.body = data;
    throw error;
  }
}

// ═══ Project members ═══

export async function fetchProjectMembers(token, projectId) {
  const res = await fetch(apiUrl(`projects/${projectId}/members`), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return parseResponse(res);
}

export async function fetchInvitableUsers(token, projectId, search = "") {
  const q = search ? `?search=${encodeURIComponent(search)}` : "";
  const res = await fetch(apiUrl(`projects/${projectId}/invitable-users${q}`), {
    headers: { Authorization: `Bearer ${token}` },
  });
  return parseResponse(res);
}

export async function addProjectMember(token, projectId, userId, role) {
  const res = await fetch(apiUrl(`projects/${projectId}/members`), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ user_id: userId, role }),
  });
  return parseResponse(res);
}

export async function updateProjectMember(token, projectId, memberId, userId, role) {
  const res = await fetch(apiUrl(`projects/${projectId}/members/${memberId}`), {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ user_id: userId, role }),
  });
  return parseResponse(res);
}

export async function removeProjectMember(token, projectId, memberId) {
  const res = await fetch(apiUrl(`projects/${projectId}/members/${memberId}`), {
    method: "DELETE",
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok && res.status !== 204) {
    const data = await res.json().catch(() => ({}));
    const error = new Error(data?.detail || "Unable to remove member");
    error.status = res.status;
    throw error;
  }
  return true;
}
